/**
 * event-edit-description.js
 */

import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import analytics from 'utils/analytics';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import FormGridContainer from 'components/menu-drawer/form-grid-container';
import FormGridItem from 'components/menu-drawer/form-grid-item';
import EditorTextTemplates from 'components/editor-text-templates';
import TextField from 'components/form-inputs/text-field';


export default function EventEditDescription(props) {
  const {
    drawerState,
    translation,
    options
  } = props;  
  const { t } = useTranslation(translation);
  const formContext = useFormContext();

  return (
    <>
      <HelpTextItem
        sidebarText={drawerState.sidebarText}
        title={t('optional.description.helpTitle')}
        text={t('optional.description.helpInfo')}
      >
        {focusHandlers =>
          <FormGridContainer> 
            <FormGridItem sm={12} md={12} lg={12} xl={12}>
              <EditorTextTemplates
                recent={options.recentEntries.description}
                translation={translation}
                samplesTranslationKey='optional.description.templates'
                onSelect={value => {
                  analytics.trackGA4('event', { name: 'record_templateset', params: { record_type: 'event', template_type: 'comments' } });
                  const currValue = formContext.getValues('description');
                  const newValue = `${currValue}${currValue ? '\n\n' : ''}${value}`;
                  formContext.setValue('description', newValue, { shouldDirty: true });
                }}
              />
              <TextField
                name='description'
                label={t('optional.description.label')}              
                focusHandlers={focusHandlers}
                style={{ width: '100%' }}
                multiline
                rows={6}
              />
            </FormGridItem>
          </FormGridContainer>}
      </HelpTextItem>
    </>
  );
}